import { Nullable } from '../../models/utils'

export interface IFormattedFinanceOptions {
  withCurrencySign?: boolean
  currency?: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  signDisplay?: 'auto' | 'never' | 'always' | 'exceptZero'
}

const formatCurrency = (
  value?: Nullable<string | number>,
  options: IFormattedFinanceOptions = {}
) => {
  const { withCurrencySign, currency, maximumFractionDigits, minimumFractionDigits, signDisplay } =
    options

  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD',
    signDisplay,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(Number(value))

  if (withCurrencySign) {
    return formatted
  }

  return formatted.replace('$', '')
}

export const getFormattedFinance = (
  value?: Nullable<string | number>,
  options: IFormattedFinanceOptions = {}
) => {
  if (value === null || value === undefined) {
    return '-'
  }

  try {
    return formatCurrency(value, options)
  } catch (error) {
    return formatCurrency(value, {
      ...options,
      currency: 'USD',
      withCurrencySign: false,
    })
  }
}
